module.exports = __webpack_public_path__ + "img/occasion-mark-sprite.d0ec2b9e.svg";